module.exports = __webpack_public_path__ + "img/logo.81223b06.png";